var exports = {
  "R": "FocusRing.module__focusRing___SjZqcT",
};

module.exports = exports;
